import { useEffect, useState } from "react";
import "./TimeZone.css"; // import the CSS file

export default function TimeZoneCheckerModal() {
  const [showModal, setShowModal] = useState(false);
  const [userTimeZone, setUserTimeZone] = useState("");

  useEffect(() => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setUserTimeZone(tz);

    // The interest maths needs GMT (UTC+0), which Accra already is, so check
    // the offset rather than the zone's name
    if (new Date().getTimezoneOffset() !== 0) {
      setShowModal(true);
    }
  }, []);

  if (!showModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2 className="modal-title">Timezone Warning</h2>
        <p className="modal-text">
          Your system timezone is currently set to{" "}
          <strong>{userTimeZone}</strong>.
          <br />
          Dates and interest are worked out in GMT, so please switch it to{" "}
          <strong>Ghana (Accra)</strong> or{" "}
          <strong>(UTC) Coordinated Universal Time</strong>.
          <em> Refresh this page after changes.</em>
        </p>
        <div className="modal-actions">
          <button onClick={() => setShowModal(false)} className="modal-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
